"use client";

import { useLayoutEffect, type ReactNode } from "react";

import { applyUserAccent } from "@/lib/theme/accent-color";
import { useThemeStore } from "@/store/theme-store";

type ThemeProviderProps = {
  children: ReactNode;
};

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useThemeStore((s) => s.theme);
  const accentColor = useThemeStore((s) => s.accentColor);

  useLayoutEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.dataset.theme = theme;
    applyUserAccent(accentColor);
  }, [theme, accentColor]);

  return <>{children}</>;
}
